import { Injectable } from '@angular/core';
import { ApiBaseService } from './api-base.service';
import { Observable } from 'rxjs';
import ApiOptionsConfig from './api-options.config';

const BASE_URL = '/bank-accounts';

@Injectable({
  providedIn: 'root'
})
export class BankAccountsService extends ApiBaseService {
 list(options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(BASE_URL), options?.params);
  }

  detail(banckAccountId: number, options?: ApiOptionsConfig): Observable<any> {
    return this.GET(this.getUrl(`${BASE_URL}/${banckAccountId}`), options?.params);
  }

  create(data: any): Observable<any> {
    return this.POST(this.getUrl(BASE_URL), data);
  }

  update(banckAccountId: number, data: any): Observable<any> {
    return this.PUT(this.getUrl(`${BASE_URL}/${banckAccountId}`), data);
  }

  delete(banckAccountId: number): Observable<any> {
    return this.DELETE(this.getUrl(`${BASE_URL}/${banckAccountId}`));
  }
}
